<div class="create-body">
  <mat-form-field appearance="standard" class="form-field">
    <mat-label
      class="group__label">
      {{'Enter a group name' | translate}}
    </mat-label>

    <input
      [formControl]="control"
      [placeholder]="'Name' | translate"
      autocomplete="off"
      class="group__input"
      matInput>

    <mat-error
      *ngIf="control.hasError('required')"
      class="group__error">
      {{'Name is required' | translate}}
    </mat-error>
  </mat-form-field>

  <div class="actions">
    <cui-button
      (buttonClicked)="cancel()"
      [label]="'CANCEL' | translate"
      [type]="'secondary'"
      class="cancel-button">
    </cui-button>

    <cui-button
      (buttonClicked)="save()"
      [disabled]="control.invalid"
      [label]="'SAVE' | translate"
      [type]="'primary'"
      class="save-button">
    </cui-button>
  </div>
</div>
